module.exports = __webpack_public_path__ + "static/privacy_mark-b26bbf08040b72b7e61e09943fae67e8.png";